module.exports = __webpack_public_path__ + "9805006dd94a0f831ed41e1953b0a005.png";